import type { NavSectionData } from '@layouts/dashboard/types';

import React from 'react';

import { Searchbar } from '@layouts/dashboard/components/searchbar';
import { AccountMenu } from '@layouts/dashboard/components/account-menu';

import { useIsDesktop } from '@shared/hooks/use-media-query';

import { SeasonMenu } from '@features/seasonal-theme';
import { PrinterStatusPanel } from '@features/printer';
import { DebugInfo, AdminButton } from '@features/user-access';

type HeaderActionsProps = {
  navData: NavSectionData[];
};

// Right area of the header: app status indicators + search, season theme and account.
export const HeaderActions = ({ navData }: HeaderActionsProps) => {
  // Phones keep only the essentials: printer/IP status and search live on desktop workstations.
  const isDesktop = useIsDesktop();

  return (
    <div className="flex items-center gap-1 sm:gap-1.5">
      {isDesktop && (
        <>
          <PrinterStatusPanel />
          <DebugInfo />
        </>
      )}
      <AdminButton />

      {isDesktop && <Searchbar data={navData} />}

      <SeasonMenu />

      <AccountMenu />
    </div>
  );
};
